import React from "react";
import { useSelector } from "react-redux";
import { Card, CardBody, CircularProgress } from "@nextui-org/react";
import { useTranslation } from "react-i18next";
import { BsDatabaseFill } from "react-icons/bs";

import LineChart from "../../../components/charts/LineChart";

const LineChartSection = ({ title, subtitle, data }) => {
  const { t } = useTranslation();
  const { sales_companies, loading_sales_companies } = useSelector(
    (state) => state.financial_insights.financial_insights
  );

  return (
    <Card
      shadow="none"
      className="w-full h-full max-h-84 rounded-md"
    >
      <CardBody className="2xl:px-6 2xl:flex-row 2xlspace-x-4 max-h-96 overflow-visible">
        <div className="w-full 2xl:max-w-[180px] h-auto flex justify-between">
          <div className="flex flex-col">
            {!loading_sales_companies ? (
              <h1 className="text-[24px] text-primary font-semibold">{t(title)}</h1>
            ) : (
              <p className="text-sm text-gray-300">Loading...</p>
            )}
            <div className="flex items-center w-full space-x-2">
              <span className="text-xs text-gray-400 whitespace-nowrap">{t(subtitle)}</span>
              {/* <IoMdArrowDropup className="w-4 h-4 text-success" /> */}
              {/* <span className=" text-success text-[12px] leading-3 font-medium">+2.45</span> */}
            </div>
            {/* <div className="text-success flex items-center space-x-2 mt-1">
                <IoIosCheckmarkCircle />
                <span className="text-xs font-semibold">{t("On track")}</span>
              </div> */}
          </div>
        </div>
        <div className="flex-1 w-full pt-4">
          {loading_sales_companies && (
            <div className="flex flex-col justify-center items-center w-auto h-96 m-auto text-sm">
              <CircularProgress
                aria-label="Loading..."
                color="primary"
                label="Loading..."
              />
            </div>
          )}
          {!loading_sales_companies &&
          sales_companies &&
          Object.values(sales_companies).length > 0 ? (
            <LineChart
              data={sales_companies}
              minMaxAxisDiffFactor={0.35}
              type="sales_companies"
              title="Grades"
            />
          ) : !loading_sales_companies ? (
            <div className="w-full h-full flex-1 flex flex-col items-center justify-center">
              <BsDatabaseFill className="text-gray-300 w-12 h-12" />
              <h3 className="text-sm text-gray-400 mt-3">{t("No records to display")}</h3>
            </div>
          ) : null}
        </div>
      </CardBody>
    </Card>
  );
};

export default LineChartSection;
